import localforage from 'localforage';

export interface AthleteSettings {
  weight: number; // kg
  height: number; // cm
  ftp: number; // W
  lthr: number; // bpm
  maxHr: number; // bpm
  css: string; // e.g., "1:42" (min:sec / 100m)
  runThreshold: string; // e.g., "5:00" (min:sec / km)
}

export const DEFAULT_SETTINGS: AthleteSettings = {
  weight: 92,
  height: 183,
  ftp: 184,
  lthr: 181,
  maxHr: 197,
  css: '1:42',
  runThreshold: '5:00',
};

export async function getAthleteSettings(): Promise<AthleteSettings> {
  try {
    const saved = await localforage.getItem<AthleteSettings>('athlete_settings');
    return saved || DEFAULT_SETTINGS;
  } catch (err) {
    return DEFAULT_SETTINGS;
  }
}

export async function saveAthleteSettings(settings: AthleteSettings) {
  try {
    await localforage.setItem('athlete_settings', settings);
  } catch (err) {
    console.error('Failed to save athlete settings', err);
  }
}
